module.exports = __webpack_public_path__ + "img/learn-more-illu-delivered.69289d03.svg";